import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../../routes';
import { TableRowSelect } from './tr-select';
import { TableRowInput } from './tr-input';

export default class TableCadena extends Component {
     
    constructor(props) {
        super(props);
        this.state = { 
            baseUrl: document.getElementById('baseUrl').value,
        };
    }

    render() {

        const { baseUrl } = this.state;
        const { cadena, versiones, onChangeInputTableCadena, onSaveParamsCadena, onChangeInputTableImagen, onChange, regimenFiscales, Cancelacionversiones } = this.props;
        const options = versiones.map((item, index) => <option key={index} value={item}>{item}</option>);
        const options3 = Cancelacionversiones.map((item, index) => <option key={index} value={item}>{item}</option>);
        const options2 = regimenFiscales.map((item, index) => <option key={index} value={item.Regimen_Clave}>{item.Regimen_Clave} - {item.Regimen_Descripcion}</option>);

        return(
            <div className="table-responsive">
                <table className="table table-sm">
                    <tbody>
                       
                        <TableRowInput   title="Llave"
                                            type="text"
                                            name="Cadena_Fiscal_LLave"
                                            value={cadena.Cadena_Fiscal_LLave}
                                            onChange={onChangeInputTableCadena}
                         />
                        <TableRowInput   title="N° Certificado"
                                            type="text"
                                            name="Cadena_Fiscal_NoCertificado"
                                            value={cadena.Cadena_Fiscal_NoCertificado}
                                            onChange={onChangeInputTableCadena}
                         />
                        <TableRowInput   title="Certificado"
                                            type="text"
                                            name="Cadena_Fiscal_Certificado"
                                            value={cadena.Cadena_Fiscal_Certificado}
                                            onChange={onChangeInputTableCadena}
                        />
                        <TableRowInput title="Máximo de Cancelación por Sustitución en Automático"
                            type="text"
                            name="Cadena_CFDI_Monto_Maximo_Cancelacion"
                            value={cadena.Cadena_CFDI_Monto_Maximo_Cancelacion}
                            onChange={onChangeInputTableCadena}
                        />
                        <TableRowInput title="Leyenda de Cancelación con Autorización"
                            type="text"
                            name="Cadena_CFDI_Leyenda_Cancelacion"
                            value={cadena.Cadena_CFDI_Leyenda_Cancelacion}
                            onChange={onChangeInputTableCadena}
                        />
                        {/*<TableRowInput   title="Global RFC"*/}
                        {/*                    type="text"*/}
                        {/*                    name="Cadena_Factura_Global_RFC"*/}
                        {/*                    value={cadena.Cadena_Factura_Global_RFC}*/}
                        {/*                    onChange={onChangeInputTableCadena}*/}
                        {/* />*/}
                        {/*<TableRowInput   title="Global Concepto"*/}
                        {/*                    type="text"*/}
                        {/*                    name="Cadena_Factura_Global_Concepto"*/}
                        {/*                    value={cadena.Cadena_Factura_Global_Concepto}*/}
                        {/*                    onChange={onChangeInputTableCadena}*/}
                        {/* />*/}
                        {/*<TableRowInput   title="Global Serie"*/}
                        {/*                    type="text"*/}
                        {/*                    name="Cadena_Factura_Global_Serie"*/}
                        {/*                    value={cadena.Cadena_Factura_Global_Serie}*/}
                        {/*                    onChange={onChangeInputTableCadena}*/}
                        {/* />*/}
                        {/*<TableRowInput   title="Global Folio"*/}
                        {/*                    type="text"*/}
                        {/*                    name="Cadena_Factura_Global_Folio"*/}
                        {/*                    value={cadena.Cadena_Factura_Global_Folio}*/}
                        {/*                    onChange={onChangeInputTableCadena}*/}
                        {/*/>*/}
                        <TableRowSelect title="Versión CFDI"
                            name="Cadena_CFDI_Version"
                            options={options}
                            value={cadena.Cadena_CFDI_Version}
                            onChange={onChange}
                        />
                        <TableRowSelect title="Regimen Fiscal"
                            name="Cadena_Regimen_Codigo"
                            options={options2}
                            value={cadena.Cadena_Regimen_Codigo}
                            onChange={onChange}
                        />
                        <TableRowInput title="Leyenda Web"
                            type="text"
                            name="Cadena_Leyenda_Web"
                            value={cadena.Cadena_Leyenda_Web}
                            onChange={onChangeInputTableCadena}
                        />
                        <TableRowSelect title="Versión Cancelción CFDI"
                            name="Cadena_CFDI_Cancelcion_Version"
                            options={options3}
                            value={cadena.Cadena_CFDI_Cancelcion_Version}
                            onChange={onChange}
                        />
                        <tr>
                            <td colSpan="2">
                                <input type="file" className='btn btn-outline-primary' onChange={onChangeInputTableImagen} />                                
                            </td>

                        </tr>
                        <tr>
                            <td colSpan="2">
                                <button type="button" className="btn btn-custom-theme float-right"><i className="far fa-save" onClick={onSaveParamsCadena}></i></button>
                                <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right">
                                    <i className="fas fa-angle-double-left"></i>
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/tabla-cadena.jsx